export const RemixType = 'remix';
